module.exports = __webpack_public_path__ + "img/O que  não fazer com restos de poda 2.1ed07310.webp";